import * as React from 'react'
import { connect } from 'react-redux'
import { closePopupLayer, GlobalPopupLayerState } from 'common/ducks/popupLayer'
import { CommonState } from 'common/types/commonState'
import { DynamicCx } from 'common/types'
import { lockBodyScroll, unlockBodyScroll } from 'common/utils/DOMUtils'
import { KeyCode } from 'common/constants/keyCode'

interface StateProps {
  popupLayerState: GlobalPopupLayerState
}

interface DispatchProps {
  closePopupLayer: typeof closePopupLayer
}

interface OwnProps {
  overPopup?: boolean
  cx?: DynamicCx
}

type Props = StateProps & DispatchProps & OwnProps

class PopupLayer extends React.PureComponent<Props, {}> {
  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = e => {
    if (e.keyCode === KeyCode.ESCAPE) {
      this.props.closePopupLayer()
    }
  }

  handleDimmedClick = event => {
    if (event && event.target && event.target === event.currentTarget) {
      this.props.popupLayerState.executeFunctionAtClose && this.props.popupLayerState.executeFunctionAtClose()
      this.props.closePopupLayer()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.popupLayerState.element !== null && this.props.popupLayerState.element === null) {
      unlockBodyScroll()
      return
    }

    if (prevProps.popupLayerState.element === null && this.props.popupLayerState.element !== null) {
      lockBodyScroll()
      return
    }
  }

  render() {
    const { overPopup } = this.props

    let popupLayerState = this.props.popupLayerState
    if (overPopup) {
      popupLayerState = this.props.popupLayerState.overElement
    }

    if (!popupLayerState || !popupLayerState.element) return null

    const className =
      popupLayerState.classNames && popupLayerState.classNames.length > 0 ? popupLayerState.classNames.join(' ') : ''

    return (
      <div
        onClick={this.handleDimmedClick}
        className={className}
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          zIndex: 20000,
          width: '100%',
          height: '100%',
          margin: '0 auto',
          backgroundColor: 'rgba(0,0,0,0.7)',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}>
        {popupLayerState.element}
      </div>
    )
  }
}

export default connect<StateProps, DispatchProps>(
  (state: CommonState) => ({
    popupLayerState: state.globalPopupLayer,
  }),
  {
    closePopupLayer,
  },
)(PopupLayer)
